module.exports = __webpack_public_path__ + "img/icon-centerpoint-light.73f06cf3.svg";